import { defineComponent as r, openBlock as n, createBlock as a, unref as l, mergeProps as i, withCtx as p, createElementVNode as c } from "vue";
import { RevIcon as m } from "@ds/components/Icon";
const u = /* @__PURE__ */ r({
  name: "IconPriceTagFilled",
  __name: "IconPriceTagFilled",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(t) {
    const o = t;
    return (s, e) => (n(), a(l(m), i(o, { "view-box": "0 0 24 24" }), {
      default: p(() => [...e[0] || (e[0] = [
        c("path", { d: "M10.4 2.785a1.25 1.25 0 0 1 .883.366l8.693 8.693a1.25 1.25 0 0 1 0 1.767l-6.365 6.365a1.25 1.25 0 0 1-1.767 0L3.15 11.283A1.25 1.25 0 0 1 2.785 10.4V4.035l.007-.128a1.25 1.25 0 0 1 1.243-1.122H10.4M7.5 6a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  u as default
};
